import axios from 'axios'
import env from '@/config'

const NO_REFRESH_PATHS = ['/auth/refresh', '/auth/logout', '/auth/user/login']

export const http = axios.create({
  baseURL: env.api.appbox.baseURL,
  timeout: 30000,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

let refreshInFlight = null

function refreshSession() {
  if (!refreshInFlight) {
    refreshInFlight = http
      .post('/auth/refresh', null, { skipAuthRefresh: true })
      .finally(() => {
        refreshInFlight = null
      })
  }

  return refreshInFlight
}

let onUnauthorized = async () => {
  const { default: router } = await import('@/router')

  if (router.currentRoute.value.name !== 'login') {
    router.push({ name: 'login' })
  }
}

export function setUnauthorizedHandler(handler) {
  onUnauthorized = handler
}

function canRetry(config) {
  if (!config || config.skipAuthRefresh || config.retriedAfterRefresh) {
    return false
  }

  const url = config.url || ''

  return !NO_REFRESH_PATHS.some((path) => url.includes(path))
}

http.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error?.config

    if (error?.response?.status !== 401 || !canRetry(config)) {
      return Promise.reject(error)
    }

    config.retriedAfterRefresh = true

    try {
      await refreshSession()
    } catch (falhaNaRenovacao) {
      const sessaoEncerrada = falhaNaRenovacao?.response?.status === 401

      if (sessaoEncerrada && config.notifySessionExpired !== false) {
        await onUnauthorized()
      }

      return Promise.reject(error)
    }

    return http(config)
  }
)

export default http
